import AdBanner from '@/components/AdBanner'
import AppDownloadOptIn from '@/components/AppDownloadOptIn'
import ContentfulOrderWrapper from '@/components/ContentfulOrderWrapper/ContentfulOrderWrapper'
import EmailSignUp from '@/components/EmailSignUp'
import ExpressDealDialog from '@/components/Hotels/ExpressDeal/ExpressDealDialog'
import LayoutComponentWrapper from '@/components/LayoutComponentWrapper'
import PromoBanners from '@/components/MerchModuleWrapper/PromoBanners'
import MediaCardComponent from '@/components/Promos/MediaCard/MediaCardComponent'
import LinksWidget from '@/components/SkyMondeSeo/LinksWidget'
import WhyPricelineBanner from '@/components/WhyPricelineBanner/WhyPricelineBanner'
import { REASONS_HOME } from '@/constants/reasons'
import useBootstrapData from '@/hooks/useBootstrapData'
import useContentfulVariation from '@/hooks/useContentfulVariation'
import useExpressDealDialog from '@/hooks/useExpressDealDialog'
import analytics from '@/shared-utils/analytics'
import {
  isCollectionOfIMediaCard,
  isCollectionOfIMerchModule,
  isISpotlightCollection,
} from '@/shared-utils/content-model-type-guards'
import mapSpotlightCollectionData from '@/shared-utils/map-spotlight-collection-data'
import { SpotlightCollection } from '@pcln/cards'
import { useContentfulWithPredicate } from '@pcln/contentful-components'
import { useFeature } from '@pcln/feature-components'
import { MediaCardCollection } from '@pcln/marketing'
import { Box, Container } from 'pcln-design-system'
import { useEffect } from 'react'
import TripDisplayOrder from './TripDisplayOrder'

const expressDealQSKey = 'expressdeal'
const expressDealQSValue = 'y'

function AdBannerContent() {
  return (
    <AdBanner>
      <div id='div-gpt-ad-1614716188275-0' />
    </AdBanner>
  )
}

export default function HomeContent() {
  const { skymondeSEO } = useBootstrapData()

  const { isOpen, closeDialog } = useExpressDealDialog(expressDealQSKey, expressDealQSValue)
  const spotlightCollectionContentfulData = useContentfulVariation(
    'spotlightCollection',
    isISpotlightCollection,
  )

  const promoCollection = useContentfulWithPredicate('promoCollection', isCollectionOfIMerchModule)
  const promoItems = promoCollection?.items || ([] as const)

  const mediaCardCollectionData = useContentfulVariation('mediaCardPromoCollection', isCollectionOfIMediaCard)

  const mappedSpotlightCollectionData = spotlightCollectionContentfulData
    ? mapSpotlightCollectionData(spotlightCollectionContentfulData)
    : null

  const showBfcmEmailOptIn = useFeature('siteExperience.isBFCM2024EmailSignUpEnabled') ?? false

  useEffect(() => {
    const spotlightGA4params = spotlightCollectionContentfulData?.analyticsTracking?.parameters
    if (spotlightGA4params) {
      analytics.fireGA4Event(spotlightGA4params)
    }
  }, [spotlightCollectionContentfulData])

  return (
    <Container size='xl' mb={5}>
      <ExpressDealDialog isOpen={isOpen} closeDialog={closeDialog} />
      <Box mb={[0, null, spotlightCollectionContentfulData || showBfcmEmailOptIn ? 4 : 1]} mt={4}>
        <TripDisplayOrder />
      </Box>
      <LayoutComponentWrapper>
        {showBfcmEmailOptIn && <EmailSignUp appCode='DESKTOP' bfcmEmailOptIn sourceId='LANDING_HOME' />}
        {mappedSpotlightCollectionData && (
          <SpotlightCollection
            spotlightData={mappedSpotlightCollectionData}
            onClickCallToAction={() => {
              const ga4Parameters = mappedSpotlightCollectionData?.callToAction?.analyticsTracking?.parameters
              if (ga4Parameters) {
                analytics.fireGA4Event(ga4Parameters)
              }
              window.open(mappedSpotlightCollectionData?.callToAction?.url)
            }}
          />
        )}
      </LayoutComponentWrapper>
      <LayoutComponentWrapper topGap>
        <ContentfulOrderWrapper />
        <AppDownloadOptIn />
      </LayoutComponentWrapper>
      <LayoutComponentWrapper topGap>
        {!showBfcmEmailOptIn && <EmailSignUp appCode='DESKTOP' sourceId='LANDING_HOME' />}
        <MediaCardCollection collection={mediaCardCollectionData} cardNode={MediaCardComponent} />
        <PromoBanners merchModules={promoItems} />
        <WhyPricelineBanner content={REASONS_HOME} />
        <AdBannerContent />
        {skymondeSEO && <LinksWidget data={skymondeSEO} />}
      </LayoutComponentWrapper>
    </Container>
  )
}
